import { render, staticRenderFns } from "./CheckoutModalConfirmOrder.vue?vue&type=template&id=25ba53ec&scoped=true"
import script from "./CheckoutModalConfirmOrder.vue?vue&type=script&lang=js"
export * from "./CheckoutModalConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "./CheckoutModalConfirmOrder.vue?vue&type=style&index=0&id=25ba53ec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba53ec",
  null
  
)

export default component.exports